
import { formatPhoneNumber } from './formatPhoneNumber';
import { WhatsAppSettings } from './whatsAppSettings';

/**
 * Creates a WhatsApp URL for the given target number and message
 * @param targetNumber The target WhatsApp number
 * @param message The message to be pre-filled
 * @returns The WhatsApp URL
 */
export const createWhatsAppLink = (targetNumber: string, message: string): string => {
  const formattedNumber = formatPhoneNumber(targetNumber);
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${formattedNumber}?text=${encodedMessage}`;
};

/**
 * Creates a default WhatsApp message based on the admin status
 * @param isAdmin Whether the message is from an admin
 * @returns A default message
 */
export const createDefaultMessage = (isAdmin: boolean): string => {
  return isAdmin
    ? "Olá! Sou da TaxHealth e estou entrando em contato sobre seu interesse em nossos serviços de benefícios fiscais."
    : "Olá! Acabei de fazer o teste na página da TaxHealth e fui aprovado para o benefício fiscal. Gostaria de entender os próximos passos.";
};

/**
 * Opens a WhatsApp chat with the given URL
 * @param url The WhatsApp URL to open
 */
export const openWhatsAppChat = (url: string): void => {
  console.log('📱 Opening WhatsApp URL:', url);
  
  // Prevent multiple simultaneous opens by adding a small delay check
  if ((window as any)._whatsappOpening) {
    console.log('🚫 WhatsApp already opening, skipping...');
    return;
  }
  
  (window as any)._whatsappOpening = true;
  window.open(url, '_blank');
  
  // Reset the flag after a short delay
  setTimeout(() => {
    (window as any)._whatsappOpening = false;
  }, 2000);
};

/**
 * Creates a WhatsApp link based on the given settings and admin status
 * @param settings The WhatsApp settings
 * @param phoneNumber The phone number (used when admin is contacting lead)
 * @param isAdmin Whether the admin is initiating the contact
 * @returns The WhatsApp URL
 */
export const createWhatsAppLinkFromSettings = (
  settings: WhatsAppSettings,
  phoneNumber: string,
  isAdmin: boolean
): string => {
  // Determine target number based on who is initiating contact
  const targetNumber = isAdmin
    ? phoneNumber // Admin contacting lead
    : settings.whatsapp_number; // Lead contacting admin
  
  // Select the appropriate message
  const message = isAdmin ? settings.admin_message : settings.form_message;
  
  return createWhatsAppLink(targetNumber, message);
};
